import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import i18n from "@/i18n";

import { PrivacyPage } from "@/pages/privacy";

export const Route = createFileRoute("/privacy")({
  head: () => {
    const t = i18n.getFixedT("nl", "privacy");
    return pageHead({
      lang: "nl",
      pathWithoutLang: "/privacy",
      title: t("seo.title"),
      description: t("seo.description"),
    });
  },
  component: PrivacyPage,
});
